import api from ".";

export const getCategories = () => api.get("/categories");
export const verifyProfileComplete = (phonenumber: string) =>
  api.get(`/auth/verifyProfileComplete?phonenumber=${phonenumber}`);
export const getPlatformLogo = () => api.get(`/platform/logo`);
export const updatePlatformCurrency = (currency: string) =>
  api.put("/platform/currency", { currency });
export const createCategory = (data: { name: string }) =>
  api.post("/categories", data);
export const updateCategory = (id: string, data: { name: string }) =>
  api.put(`/categories/${id}`, data);
export const deleteCategory = (id: string) => api.delete(`/categories/${id}`);

//Roles
export const getRoles = () => api.get("/roles");
export const createRole = (data: { name: string }) => api.post("/roles", data);
export const deleteRole = (id: string) => api.delete(`/roles/${id}`);

//OrderStatus
export const updateOrderStatus = async (id: string, orderStatus: string) =>
  api.patch(`/orders/${id}/status`, { orderStatus });

export const cancelOrderItem = (orderId: string, itemId: string) => {
  return api.put(`/orders/${orderId}/item/${itemId}/cancel`);
};

export const signup = (data: {
  name: string;
  email: string;
  phonenumber: string;
  password: string;
}) => {
  return api.post("/auth/signup", data);
};

export const signin = (data: { email: string; password: string }) => {
  return api.post("/auth/login", data);
};

export const verifyOtp = (data: { phonenumber: string; otp: string }) => {
  return api.post("/auth/verify-otp", data);
};

export const applySignupCode = (data: { userId: string; code: string }) => {
  // Update endpoint path as needed on backend.
  return api.post("/wallet/redeemUserGiftCard", data);
};

export const verifymodalOtp = (data: { email: string; otp: string }) => {
  return api.post("/auth/verifymodal-otp", data);
};
export const generateOtp = (data: { email: string }) => {
  return api.post("/auth/otp-gen", data);
};
export const generateOtpPass = (data: { email: string }) => {
  return api.post("/auth/otpChangePass", data);
};

export const resetPassword = (data: { email: string; newPassword: string }) => {
  return api.post("/auth/reset-password", data);
};
export const getPlaceAutocomplete = (
  input: string,
  lat?: number,
  lng?: number,
  sessionToken?: string,
) =>
  api.get(
    `/address/place-autocomplete?input=${encodeURIComponent(input)}${
      typeof lat === "number" && typeof lng === "number"
        ? `&lat=${lat}&lng=${lng}`
        : ""
    }${sessionToken ? `&sessionToken=${encodeURIComponent(sessionToken)}` : ""}`,
  );
export const getPlaceDetails = (lat: number, lng: number) =>
  api.get(`/address/place-details?lat=${lat}&lng=${lng}`);
export const getPlaceDetailsById = (placeId: string, sessionToken?: string) =>
  api.get(
    `/address/place-details-by-id?placeId=${encodeURIComponent(placeId)}${
      sessionToken ? `&sessionToken=${encodeURIComponent(sessionToken)}` : ""
    }`,
  );
export const genrateOrderQuote = (data: {
  dropoff_address: string;
  dropoff_latitude: number;
  dropoff_longitude: number;
  pickup_time: string;
}) => {
  return api.post("/uber/uber-genrate-order-quote", data);
};
// Profile API to update //
export const updateProfile = (data: {
  userId: string;
  name?: string;
  newEmail?: string;
  oldPassword?: string;
  newPassword?: string;
  birthday?: { month: number; day: number } | null;
}) => {
  return api.post("/auth/updation", data);
};

export const createOrder = (data: {
  pickup_name: string;
  pickup_address: string;
  pickup_phone_number: string;
  dropoff_name: string;
  dropoff_address: string;
  dropoff_phone_number: string;
  manifest_items: any[];
}) => {
  return api.post("/uber/uber-create-order", data);
};
export const createDoorDashOrder = (data: {
  pickup_name: string;
  pickup_address: string;
  pickup_phone_number: string;
  dropoff_name: string;
  dropoff_address: string;
  dropoff_phone_number: string;
  manifest_items: any[];
}) => {
  return api.post("/doorDash/createOrder", data);
};

export const getOrderDetails = (delivery_id: string) => {
  return api.get(`/uber/uber-get-order-details/${delivery_id}`);
};

export const getHotelInformation = () => {
  return api.get(`/admin/get-hotel-info`);
};

export const checkoutSession = (data: {
  amount: number;
  productName: string;
}) => {
  return api.post("/stripe/create-checkout-session", data);
};

export const paymentSession = (session_id: string) => {
  return api.get(`/stripe/get-payment-session?session_id=${session_id}`);
};

export const createSquarePayment = (data: {
  token: string;
  amount: number;
  hotelId?: string;
}) => {
  return api.post("/square/createPayment", data);
};

export const saveTransactions = (data: {
  phoneNumber: string;
  email: string;
  amount: string;
  currency: string;
  transaction_id: string;
  promotionalEmails: boolean;
  promotionalTexts: boolean;
}) => {
  return api.post("/stripe/save-transactions", data);
};

export const addBalancetowallet = (data: {
  amount: number;
  userId: string;
}) => {
  return api.post("/wallet/addToWallet", data);
};

export interface DiscountLevel {
  _id: string;
  name: string;
  minPoints: number;
  maxPoints: number;
  discount: number;
  color: string;
  minPointExpiryDays: number;
  maxPointExpiryDays: number;
  createdAt: string;
  updatedAt: string;
}

export interface LoyaltyPhoneData {
  _id: string;
  phoneNumber: string;
  startDate: string;
  spendAmount: number;
  currentLevel: DiscountLevel;
  points: number;
  createdAt: string;
  updatedAt: string;
}

export const getDiscountLevels = () => api.get("/discounts");

export const trackOrder = (orderNumber: string) =>
  api.get(`/orders/track/${encodeURIComponent(orderNumber)}`);

export const getLoyaltyByPhone = (phoneNumber: string) =>
  api.get(`/loyalty/${encodeURIComponent(phoneNumber)}`);
